<template>
  <div class="p_radar_content">
    <div class="topOperation">
        <div class="top-left">
            <div><ShowNavHead/></div>
            <div class="screenInputs">
                <div class="screenInput">
                    <div class="flname">地区</div>
                    <el-input v-model="listQuery.straddr" size="small" clearable @keyup.enter.native="searchHandle"></el-input>
                </div>
                <div class="screenInput">
                  <div class="flname">时间</div>
                  <el-date-picker v-if="tabAcitve == 'first'" @change="changeWeek" class="r_week_box"
                    v-model="valWeek" :picker-options="pickerOptions"
                    type="week" size="small" :clearable="false"
                    :format="listQuery.strstartdate + ' 至 ' + listQuery.strenddate"
                    placeholder="选择周">
                  </el-date-picker>
                  <div v-else class="t_search_box">
                    <el-date-picker
                      v-model="listQuery.strstartdate" placeholder="开始日期"
                      type="date" size="small"
                      value-format="yyyy-MM-dd"
                      range-separator="至" :clearable="false">
                    </el-date-picker>
                    <span>至</span>
                    <el-date-picker
                      v-model="listQuery.strenddate" placeholder="结束日期"
                      type="date" size="small"
                      value-format="yyyy-MM-dd"
                      :clearable="false">
                    </el-date-picker>
                  </div>
                </div>
                <div class="screenInput" v-if="tabAcitve != 'first'">
                  <div class="flname">姓名</div>
                  <el-select v-model="listQuery.gduserid" clearable size="small" filterable placeholder="">
                    <el-option v-for="(item,index) in userList" :key="index" :label="item.Username" :value="item.Userid"></el-option>
                  </el-select>
                </div>
                <div class="screenInput screen_btn">
                    <el-button :disabled="tableLoading" type="success" size="small" @click="searchHandle">搜索</el-button>
                </div>
            </div>
        </div>
        <!-- <div class="top-right">
            <el-button v-if="(isExport && this.tableData.length > 0)" type="warning" plain size="small" @click="exportHandle" :loading="btnLoading" :style="'margin-right:' +(!isExport && (tableData == [])?'0':'16px')">导出</el-button>
        </div> -->
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>产品</el-breadcrumb-item>
          <el-breadcrumb-item>营销雷达</el-breadcrumb-item>
          <el-breadcrumb-item>管理</el-breadcrumb-item>
          <el-breadcrumb-item>数据看板</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="p_radar_table">
        <comTabs ref="child" :active="activeName"></comTabs>
        <el-tabs v-model="tabAcitve" @tab-click="handleClick" class="m_tabs_box">
          <el-tab-pane :disabled="tableLoading" label="资源数据" name="first"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="销售雷达-业务认领跟进统计表" name="second"></el-tab-pane>
          <el-tab-pane :disabled="tableLoading" label="嫂子VIP-业务认领跟进统计表" name="third"></el-tab-pane>
        </el-tabs>
        <div class="m_tabs_box">
          <div class="report_export_box">
            <el-button v-if="!isNull(tableData)" type="primary" size="small" @click="exportHandle" :loading="btnLoading">导出</el-button>
          </div>
          <el-table border v-loading="tableLoading" :header-cell-style="{background:'#f5f7fa'}" :highlight-current-row="true" :max-height="tableHeight-100" :data="tableData" style="width:100%">
            <el-table-column align="center" label="序号" width="60px" fit :show-overflow-tooltip="true">
              <template slot-scope="{$index}">
                  <span>{{(Number(listQuery.currpage) - 1) * Number(listQuery.perpage) + Number($index) + 1}}</span>
                </template>
            </el-table-column>
            <template v-for="(item,index) in tableTitle">
              <el-table-column :prop="item.StrColumId" :label="item.StrColumName" fit :show-overflow-tooltip="true" :key="index" :min-width="item.StrColumName.indexOf('全称')>-1?('250px'):(item.StrColumName.indexOf('简称')>-1||item.StrColumName.indexOf('日期')>-1||item.StrColumName.indexOf('贡献数')>-1?'170px':'100px')" align="center"
                >
                <template slot-scope="{row}">
                  <span v-if="item.StrColumId == 'Followstat'">{{row.Followstat == '1'||Number(row.Followstat) > '1'?'已跟进':'未跟进'}}</span>
                  <span v-else-if="item.StrColumId == 'Claimstatu'">{{row.Claimstatu == '1'?'已认领':'未认领'}}</span>
                  <span v-else>{{ row[item.StrColumId] }}</span>
                </template>
              </el-table-column>
            </template>
          </el-table>
        </div>
        <div class="block">
          <el-pagination
            @current-change="changeBPage"
            :current-page.sync="listQuery.currpage"
            :page-size="listQuery.perpage"
            @size-change="handleSizeChange"
            :page-sizes="[10, 20, 50, 100]"
            layout="total,sizes,prev,pager,next,jumper"
            :total="total"
          ></el-pagination>
      </div>
      </div>
    </div>
  </div>
</template>
<script>
import xz from "@/common"
import moment from 'moment'
import comTabs from './components/comTab.vue'
export default {
  components:{
    comTabs
  },
  name: "radarManage",
  data() {
    return {
      // 列表参数
      listQuery:{
        strTableId:'JBRegionDayEnt',//（表头也用这个）JBflowpath流程数据 JBRegionDayEnt资源数据 JBBusiFollowClaim跟进认领 JBBusiFollowClaimSz
        straddr:'',//地区
        strstartdate:'',//开始时间
        strenddate:'',//结束时间
        gduserid:'',//选择姓名
        perpage: 10,
        currpage: 1
      },
      tablePath: this.$store.state.EMP.tablePath,
      btnLoading:false,
      pickerOptions: {
        firstDayOfWeek: 1,
        disabledDate: (time) => {
          return time.getTime() < new Date('2023-04-01').getTime() + 8.64e7
        }
      },
      searchTime:[],
      tableHeight:0,
      tableLoading:false,
      tableData:[],
      // 表头
      tableTitle:[],
      total:0,
      activeName:'数据看板',
      tabAcitve:'first',
      valWeek:'',
      last_monday:'',
      last_sunday:'',
      // 导出参数
      exportQuery:{},
      userList:[]//所有人员列表
    }
  },
  created() {
    this.calHeight()
    // 获取上一周开始时间和结束时间
    let weekOfDay = new Date().getDay(); // 今天星期几
    this.last_monday = moment().subtract(weekOfDay + 7 - 1, 'days').format('YYYY-MM-DD');
    let second_day = moment(this.last_monday).add(1, 'days').format("YYYY-MM-DD");
    this.last_sunday = moment().subtract(weekOfDay, 'days').format('YYYY-MM-DD');
    // console.log('ee',last_monday,last_sunday,weekOfDay)
    this.listQuery.strstartdate = this.last_monday
    this.listQuery.strenddate = this.last_sunday
    this.valWeek = second_day
    this.getTableTitle(this.listQuery.strTableId);
    this.getAllUserList()
  },
  methods: {
    handleClick(tab){
      // console.log('ee',tab)
      this.tabAcitve = tab.name
      if(this.tabAcitve != 'first'){
        if(this.tabAcitve == 'second'){
          this.listQuery.strTableId = 'JBBusiFollowClaim'
        }else{
          this.listQuery.strTableId = 'JBBusiFollowClaimSz'
        }
        // let endDate = moment().format("YYYY-MM-DD")
        let endDate = moment().subtract(1,'days').format("YYYY-MM-DD")
        let nowdate = moment().subtract(1, 'months').format('YYYY-MM-DD');  //获取上月
        this.listQuery.strstartdate = nowdate
        this.listQuery.strenddate = endDate
        this.getTableTitle(this.listQuery.strTableId);
      }else{
        this.listQuery.strTableId = 'JBRegionDayEnt'
        // 获取上一周开始时间和结束时间
        this.listQuery.strstartdate = this.last_monday
        this.listQuery.strenddate = this.last_sunday
        this.getTableTitle(this.listQuery.strTableId);
      }
    },
    // 导出
    exportHandle(){
      let that = this
      this.$confirm('是否导出数据?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then((cur) => {
        that.exportQuery = JSON.parse(JSON.stringify(that.listQuery))
        that.exportQuery.currpage = 1
        that.exportQuery.perpage = 10000000
        that.btnLoading = true
        console.log('tableTitle', that.exportQuery)
        xz.outputReportListNew(that.exportQuery).then((res) => {
          // console.log('tableTitle', res)
          if (res.status == "ok") {
            let path = that.tablePath + res.stroutpath
            let aTag = document.createElement('a')
            aTag.href = path
            aTag.click();
          } else {
            this.$message({
              type: 'error',
              message: '导出失败，请稍后再试'
            })
            return false
          }
          that.btnLoading = false
        });
      })
    },
    // 选择周
    changeWeek(val){
      // console.log('ee',val)
      let weekOfday = moment(val).format("E"); //计算是这周第几天
      let monday = moment(val).subtract(weekOfday - 1, "days").format("YYYY-MM-DD"); //获取周一
      let sunday = moment(val).add(7 - weekOfday, "days").format("YYYY-MM-DD"); //获取周日
      // console.log(monday, sunday);
      this.listQuery.strstartdate = monday
      this.listQuery.strenddate = sunday
    },
    //判断是否为空
    isNull(o) {
        return o == undefined || o == "undefined" || (o + '').indexOf("undefined") > -1 || o == null || o == '' || o == 'null' || o == [] || o == 'NaN';
    },
    calHeight(){
      this.tableHeight = Number(document.body.clientHeight)
    //   console.log('height',this.tableHeight)
    },
    // 搜索
    searchHandle(){
      this.listQuery.currpage = 1
      this.getList()
    },
    //分页
    changeBPage(val){
        this.listQuery.currpage = Number(val)
        this.getList()
    },
    handleSizeChange(val) {
      this.listQuery.currpage = 1
      this.listQuery.perpage = Number(val)
      this.getList()
    },
    // 获取表头
    getTableTitle(strTableId) {
      xz.getEcrmColumnList(strTableId, "").then((res) => {
        // console.log('tableTitle', res)
        if (res.status == "ok") {
          this.tableTitle = res.msg;
          this.getList();
        } else {
          this.tableTitle = [];
        }
      });
    },
    // 获取列表
    getList(){
      this.tableLoading = true
      xz.getReportprodata(this.listQuery).then(res => {
        // console.log('列表', res)
        if (res.status == 'ok') {
          this.tableData = res.msg
          this.total = res.totalcount
        } else {
          this.tableData = []
          this.total = 0
        }
        this.tableLoading = false
      })
    },
    // 获取所有人员列表
    getAllUserList(){
      let dataPage = {
        currpage: 1,
        perpage: 10000000,
        keyword: "",
        strWorkState: "",
        strstation: "",
        strorgancode: ""
      }
      xz.getauthUserInfoByorgancode(dataPage).then(res => {
        if (res.status == 'ok') {
          this.userList = res.msg;
        } else {
          this.userList = [];
        }
      })
    }
  }
}
</script>
<style scoped>
.report_export_box{
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}
.p_radar_content .flname{
  min-width: 50px;
  width: 50px;
}
.t_search_box{
  display: flex;
  align-items: center;
}
.m_tabs_box{
  padding:0 20px;
}
.p_radar_table{
    background-color: #fff;
}
.p_radar_content .screen_btn{
  margin-left: 5px;
}
</style>
<style>
.p_radar_content .screenInput .el-input.r_week_box.el-date-editor{
  width: 240px!important;
}
.p_radar_content .topOperation .t_search_box .el-date-editor.el-input{
  width: 150px!important;
}
.p_radar_content .screenInput{
  margin: 0 0 10px 0px;
}
.p_radar_content .screenInput .el-input{
  width: 200px;
}
.p_radar_content .el-table .el-table__cell{
  padding: 3px 0;
}
</style>